import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { CanadianCurrencyCode } from "../../../../../objects/currencyExchange/canadianCurrencyCode";
import { WizardComponent } from "ngx-wizard";
import { Order } from "../../../../../objects/orders/order";
import { OrderService } from "../../../../../services/orderService";
import { ImporterType, ImportToType } from "../../../../../objects/calculator/public/types/type";
import { Product } from "../../../../../objects/products/product";
import { ConfigService } from "../../../../../services/configService";
import { OrderItem } from "../../../../../objects/orders/orderItem";
import { ActivatedRoute } from "@angular/router";
import { OrderOptions } from "../../../../../objects/orders/orderOptions";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import {FormHelper} from "../../../../../common/helpers/formHelper";
import { PageVisitService } from "../../../../../services/pageVisitService";
import { PageVisit } from "../../../../../objects/pages/pageVisit";
import { tap } from "rxjs/operators";

@Component({
    selector: "public-wizard-v2",
    templateUrl: "./public-wizard-v2.component.html",
    moduleId: module.id.toString()
})
export class PublicWizardV2Component implements OnInit {

    @Input()
    public order: Order = new Order();
    @Input()
    public orderItem: OrderItem = new OrderItem();
    @Input()
    public showFirstTab: boolean = true;
    @Output()
    public getAnotherQuote: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() mainElement: ElementRef;
    @Input()
    public marketingURL: string = null;

    @Output()
    public hideWizard: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public setOrderItem: EventEmitter<OrderItem> = new EventEmitter<OrderItem>();


    @Output()
    public createNewOrder: EventEmitter<Order> = new EventEmitter<Order>();
    public isNeedSendEmail: boolean = false;

    /*refs to enums*/
    public importerTypeRef = ImporterType;
    /*refs to enums end*/

    /*current states*/
    public currentYear: number;
    public currentYearRange?: number = null;
    public currentDescription?: string = null;
    public currentImportType: ImporterType = null;
    public isPusrchased?: boolean = null;
    public isThanksTabShow: boolean;
    public isEmailTextShow: boolean;
    public isAskQuestionTabShow: boolean;
    public isQuestionOrCallTabShow: boolean;
    public isSelfServeApp: boolean = false;


    @Output()
    public isQuotePage: EventEmitter<boolean> = new EventEmitter<boolean>(false);

    /**/

    /*getters*/
    public get isVehicle(): boolean {
        return CalculatorHelper.isVehicle(this.order);
    }

    /*getters end*/

    public addPageVisit(pageVisit: PageVisit){
        try{
            this.pageVisitService.add(pageVisit);
        } catch (error) {
            console.error(error);
        }
    }

    public focusInput(index: number): void{
        if( index != -1 ){
          setTimeout(()=>{
              let activeTab = this.wizardComponent.tabs.find(item => item.index == index);
              if(activeTab != undefined){
                  let focusInput = activeTab.elementRef.nativeElement.querySelector('input[data-autofocus="true"]') || activeTab.elementRef.nativeElement.querySelector('textarea[data-autofocus="true"]') ;
                  let focusSelect = activeTab.elementRef.nativeElement.querySelector('select[data-autofocus]');
                  let activeButton = activeTab.elementRef.nativeElement.querySelector('.btn.active');

                  focusSelect = null;

                  if(focusInput != null){
                      if(focusInput.value == "")
                          focusInput.focus();
                  }else if(focusSelect != null && activeButton == null){
                        let text = activeTab.elementRef.nativeElement.querySelector('.select2-selection__rendered').innerText;

                        if(text == "" || text == "OTHER COUNTRY")
                            $(focusSelect).select2('open');
                  }
                  $(focusSelect).on('blur', () => {
                      FormHelper.scrollToCalcV2TabOnMobile();
                  });
                  $(focusInput).on('blur', () => {
                      FormHelper.scrollToCalcV2TabOnMobile();
                  });
              }
          },100)
        }

        FormHelper.scrollToCalcV2TabOnMobile();

    }
    /*static data*/
    public provinceArray: Array<any> = new Array<any>();
    public canadianCurrencyCodes: CanadianCurrencyCode[] = [];
    public defaultProducts: Product[] = [];
    /*static data end*/

    @ViewChild(WizardComponent) wizardComponent: WizardComponent;

    @ViewChild('wizardFooterTemplate')
    public wizardFooterTemplate: TemplateRef<any>;

    public isIconShow(): boolean {
        if (this.wizardComponent.activeTab)
            return this.wizardComponent.activeTab.index != 17;

        return true;
    }

    public isFullWidth(): boolean {
        if (this.wizardComponent.activeTab) {
            return (this.wizardComponent.activeTab.index == 17 || this.wizardComponent.activeTab.index === 0);
        }
        return false;
    }

    constructor(public configService: ConfigService,
                public orderService: OrderService,
                private route: ActivatedRoute,
                private detectChanges: ChangeDetectorRef,
                public googleTagService: GoogleTagService,
                public pageVisitService: PageVisitService) {

    }

    public ngOnInit(): void {
        this.route.queryParamMap
            .pipe(tap(r => {
                if (!r.has('vehicleapp')) {
                    return;
                }
                this.isSelfServeApp = true;
                this.setImportType(ImporterType.Vehicle);
                this.moveToNextTab(true);
            }))
            .subscribe()

        this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;
        this.defaultProducts = this.route.snapshot.data.defaultProducts.Data.Items;

        this.provinceArray = [
            { code: "AB", name: "Alberta" },
            { code: "BC", name: "British Columbia" },
            { code: "MB", name: "Manitoba" },
            { code: "NB", name: "New Brunswick" },
            { code: "NL", name: "Newfoundland and Labrador" },
            { code: "NT", name: "Northwest Territories" },
            { code: "NS", name: "Nova Scotia" },
            { code: "NU", name: "Nunavut" },
            { code: "ON", name: "Ontario" },
            { code: "PE", name: "Prince Edward Island" },
            { code: "QC", name: "Quebec" },
            { code: "SK", name: "Saskatchewan" },
            { code: "YT", name: "Yukon" }
        ];

        this.order.IsCommercial = null;


    }

    public createdOrder(order: Order) {
        this.order = order;
        if (order.OrderItems.length > 0) {
            this.orderItem = order.OrderItems[0];
        }
        this.createNewOrder.emit(this.order);
    }

    public ngAfterViewInit(): void {
        let t = this.wizardComponent.tabs[0];
        
        if (t != null)
            t.active = true;

    }

    public setImportType(importerType: ImporterType): void {
        if (importerType == this.currentImportType) {
            this.currentImportType = null;
        }
        else {
            this.currentImportType = importerType;
            if (this.order.OrderItems.length > 0) {
                this.order.OrderItems[0].Price = null;
            }
        }


        this.detectChanges.detectChanges();
    }

    public setImportTypeToOrder(): void {

        let prevImporterType = CalculatorHelper.checkOrderImporterType(this.order);
        if (prevImporterType === undefined) {
            prevImporterType = this.currentImportType;
        }

        if(this.currentImportType !== prevImporterType){
            if( this.order.OrderItems.length > 0)
                this.order.OrderItems[0].Price = null;
            else
                this.orderItem.Price = null;
        }

        switch (this.currentImportType) {
            case ImporterType.Vehicle:
                this.order.Flag |= OrderOptions.IsVehicle;
                break;
            case ImporterType.Product:
                this.order.Flag &= ~OrderOptions.IsVehicle;
                break;
        }


    }

    public getMeanValue = (x: number, y: number) => Math.round((y + x) / 2);

    public setYear(from: number, to: number): void {
        this.currentYearRange = <number>this.getButtonValue(this.getMeanValue(from, to), this.currentYearRange);

        this.currentYear = null;

        this.detectChanges.detectChanges();
    }

    public setYearToOI(): void {
        if (this.currentYear)
            this.orderItem.Year = this.currentYear;
        else
            this.orderItem.Year = this.currentYearRange;
    };

    public getButtonValue<T = boolean>(value: T, currentValue?: T): T {
        return CalculatorHelper.getButtonValue<T>(value, currentValue);
    }

    public eventHandler(event: any) {//TODO move to helper, duplicate code in products-card.ts 203
        const val = event.target.value + String.fromCharCode(event.charCode);

        if (!/^[0-9]+$/.test(val) && (event.charCode != 0)) {
            event.preventDefault();
        }
    }

    public setPurchased(isPurchased: boolean): void {
        if (this.isPusrchased == isPurchased)
            this.isPusrchased = null;
        else
            this.isPusrchased = isPurchased;

        this.orderItem.IsPurchased = this.isPusrchased;
    }

    public showBottomText(vehicle: boolean): string {
        let index = this.wizardComponent.activeTab.index;
        switch (index) {
            case 1: {
                return '';
            }
            case 2: {
                return '';
            }
            case 3: {
                return '';
            }
            case 5: {
                return '';
            }
            case 7: {
                if (vehicle){
                    return ''
                }

                return '';
            }
            case 8: {
                return '';
            }
            case 10: {
                return '';
            }
            default: {
                return '';
            }

        }

    }

    public backToAskQuestionTab(event: any) {
        if (this.isAskQuestionTabShow) {
            event.preventDefault();

            setTimeout(_ => this.wizardComponent.nextTab(false), 0);
        }
    }


    public scrollTop(): void {
        if (this.mainElement)
            this.mainElement.nativeElement.scrollTop = 0;
    }

    public showEmailText(show: boolean) {
        this.isEmailTextShow = show;
    }

    public showThanksTab(show: boolean) {
        this.isThanksTabShow = show;
    }

    public showQuestionOrCallTab(show: boolean) {
        this.isQuestionOrCallTabShow = show;
    }

    public goToThanksTab() {

        this.isThanksTabShow = true;

        this.isAskQuestionTabShow = false;

        this.moveToNextTab(false);

    }

    public goToAskQuestionTab() {
        this.isAskQuestionTabShow = true;
        this.isThanksTabShow = false;
        this.moveToNextTab(false);
    }

    public moveToNextTab(x: boolean) {
        setTimeout(_ => this.wizardComponent.nextTab(x), 0);
    }

    public customBlur():void{
        if(window.orientation != undefined){
            let activeTab = this.wizardComponent.tabs.find(item => item.active == true);
            let inputs = activeTab.elementRef.nativeElement.querySelectorAll('input');

            for(let i = 0; i < inputs.length; ++i){
                inputs[i].blur()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/wizard/public-wizard-v2.component.ts